// comment out already migrated events
/** @deprecated please use the new event interfaces instead */ export var BiEventType;
(function(BiEventType) {
    BiEventType[BiEventType["TEST"] = 999] = "TEST";
    BiEventType[BiEventType[// PERF_METRICS = 1,
    // DEFAULT = 2,
    // SUBMIT_CONTENT = 11,
    // CLICK_REPORT_BUTTON = 20,
    // POST_FEED_VIEW = 95,
    // SCROLL_TO_LOAD_NEXT_FOLDER = 96,
    // BACK_TO_TOP = 97,
    // SCROLL_TO_LOAD_MORE = 98,
    // PAGEVIEW = 99,
    // ITEM_CLICK = 100,
    // USERNAME_CLICK = 101,
    // THUMB_FAVE = 102,
    // THUMB_CLICK_COMMENT = 105,
    // SEE_ALL_CLICK = 106,
    // USERNAME_HOVER_TO_OPEN = 107,
    // CAROUSEL_ARROW_CLICK = 108,
    // THUMB_CLICK_UNFAVE = 109,
    // SHOW_LESS_LIKE_THIS = 110,
    "USER_SYMBOL_CLICK"] = 111] = "USER_SYMBOL_CLICK";
    BiEventType[BiEventType["USERS_SYMBOL_LEARN_MORE_CLICK"] = 112] = "USERS_SYMBOL_LEARN_MORE_CLICK";
    BiEventType[BiEventType["PAGE_NAVIGATION_CLICK"] = 113] = "PAGE_NAVIGATION_CLICK";
    BiEventType[BiEventType[// TOPICS_VIEW_ALL_CLICK = 114,
    // POLL_VOTE = 115,
    "READ_MORE_CLICK"] = 116] = "READ_MORE_CLICK";
    BiEventType[BiEventType[// POST_FROM_FEED = 117,
    // SWITCH_POST_TYPE = 118,
    // NEXT_POST = 119,
    // CONTENT_NAVBAR_CLICK = 120,
    "SORT_TYPE_SELECT"] = 122] = "SORT_TYPE_SELECT";
    BiEventType[BiEventType["SEARCH_TAG_CLICK"] = 140] = "SEARCH_TAG_CLICK";
    BiEventType[BiEventType["NETWORK_BAR_NAV_CLICK"] = 160] = "NETWORK_BAR_NAV_CLICK";
    BiEventType[BiEventType["NETWORK_BAR_MENU_ICON"] = 161] = "NETWORK_BAR_MENU_ICON";
    BiEventType[BiEventType["NETWORK_BAR_3DOTS_OPEN"] = 162] = "NETWORK_BAR_3DOTS_OPEN";
    BiEventType[BiEventType["NETWORK_BAR_3DOTS_SELECT"] = 163] = "NETWORK_BAR_3DOTS_SELECT";
    BiEventType[BiEventType["NETWORK_BAR_SECTION_EXPAND_COLLAPSE"] = 164] = "NETWORK_BAR_SECTION_EXPAND_COLLAPSE";
    BiEventType[BiEventType["VIEW_GROUP_NOTIFICATION"] = 165] = "VIEW_GROUP_NOTIFICATION";
    BiEventType[BiEventType["COMMENT_ACTION"] = 180] = "COMMENT_ACTION";
    BiEventType[BiEventType["CLICK_REPLY_TO_COMMENT"] = 181] = "CLICK_REPLY_TO_COMMENT";
    BiEventType[BiEventType["LOAD_MORE_COMMENTS_CLICK"] = 182] = "LOAD_MORE_COMMENTS_CLICK";
    BiEventType[BiEventType["CLICK_ON_COMMENTS_TO_START_TYPING"] = 183] = "CLICK_ON_COMMENTS_TO_START_TYPING";
    BiEventType[BiEventType["COMMENT_BUTTON_CLICK"] = 184] = "COMMENT_BUTTON_CLICK";
    BiEventType[BiEventType["CLICK_VIEW_REPLY_TO_COMMENT"] = 185] = "CLICK_VIEW_REPLY_TO_COMMENT";
    BiEventType[BiEventType["CLICK_COMMENT_LIKE"] = 186] = "CLICK_COMMENT_LIKE";
    BiEventType[BiEventType["COMMENT_EDIT_CLICK"] = 187] = "COMMENT_EDIT_CLICK";
    BiEventType[BiEventType["COMMENT_DELETION_UNDO"] = 188] = "COMMENT_DELETION_UNDO";
    BiEventType[BiEventType["COMMENT_CANCEL_CLICK"] = 189] = "COMMENT_CANCEL_CLICK";
    BiEventType[BiEventType["PROFILE_NAV_BAR"] = 200] = "PROFILE_NAV_BAR";
    BiEventType[BiEventType["LOGIN_SCREEN_SHOW"] = 201] = "LOGIN_SCREEN_SHOW";
    BiEventType[BiEventType["LOGIN_SCREEN_SUBMIT"] = 202] = "LOGIN_SCREEN_SUBMIT";
    BiEventType[BiEventType["LOGIN_ERROR"] = 203] = "LOGIN_ERROR";
    BiEventType[BiEventType["LOGIN_REMEMBER_CLICK"] = 204] = "LOGIN_REMEMBER_CLICK";
    BiEventType[BiEventType["LOGIN_FORGOT_PASSWORD_CLICK"] = 205] = "LOGIN_FORGOT_PASSWORD_CLICK";
    BiEventType[BiEventType["TERMS_CLICK"] = 206] = "TERMS_CLICK";
    BiEventType[BiEventType["POLICY_CLICK"] = 207] = "POLICY_CLICK";
    BiEventType[BiEventType[// CONNECT_WITH_CLICK = 208,
    // CONNECT_WITH_FAILURE = 209,
    // CONNECT_WITH_SUCCESS = 210,
    "LOGIN_SUCCESS"] = 211] = "LOGIN_SUCCESS";
    BiEventType[BiEventType[// FIRST_LOGGIN_START_SHOW = 212,
    // FIRST_LOGGIN_START_SUBMIT = 213,
    // FIRST_LOGGIN_START_SUCCESS = 214,
    // FIRST_LOGGIN_START_FAILURE = 215,
    "WELCOME_SCREEN_SHOW"] = 216] = "WELCOME_SCREEN_SHOW";
    BiEventType[BiEventType["WELCOME_SCREEN_CLOSE"] = 217] = "WELCOME_SCREEN_CLOSE";
    BiEventType[BiEventType["WELCOME_START_CLICK"] = 218] = "WELCOME_START_CLICK";
    BiEventType[BiEventType["WELCOME_CHANGE_EMAIL_CLICK"] = 219] = "WELCOME_CHANGE_EMAIL_CLICK";
    BiEventType[BiEventType["INTENT_SHOW"] = 220] = "INTENT_SHOW";
    BiEventType[BiEventType["INTENT_OPTION_TOGGLE"] = 221] = "INTENT_OPTION_TOGGLE";
    BiEventType[BiEventType["INTENT_OTHER_TOGGLE"] = 222] = "INTENT_OTHER_TOGGLE";
    BiEventType[BiEventType["INTENT_OTHER_DONE"] = 223] = "INTENT_OTHER_DONE";
    BiEventType[BiEventType["INTENT_OTHER_CANCEL"] = 224] = "INTENT_OTHER_CANCEL";
    BiEventType[BiEventType["INTENT_SKIP"] = 225] = "INTENT_SKIP";
    BiEventType[BiEventType["INTENT_SUBMIT"] = 226] = "INTENT_SUBMIT";
    BiEventType[BiEventType["LOGIN_CAPTCHA_SHOW"] = 227] = "LOGIN_CAPTCHA_SHOW";
    BiEventType[BiEventType["ALMOST_DONE_SHOW"] = 228] = "ALMOST_DONE_SHOW";
    BiEventType[BiEventType["ALMOST_DONE_RESEND_CLICK"] = 229] = "ALMOST_DONE_RESEND_CLICK";
    BiEventType[BiEventType["ALMOST_DONE_CHANGE_ADDRESS_CLICK"] = 230] = "ALMOST_DONE_CHANGE_ADDRESS_CLICK";
    BiEventType[BiEventType["ALMOST_DONE_CLOSE"] = 231] = "ALMOST_DONE_CLOSE";
    BiEventType[BiEventType["VERIFICATION_SUCCESSFUL_BROWSE_ART_CLICK"] = 234] = "VERIFICATION_SUCCESSFUL_BROWSE_ART_CLICK";
    BiEventType[BiEventType["TOPICS_ONBOARDING_SHOW"] = 235] = "TOPICS_ONBOARDING_SHOW";
    BiEventType[BiEventType["TOPICS_ONBOARDING_SELECT"] = 236] = "TOPICS_ONBOARDING_SELECT";
    BiEventType[BiEventType["TOPICS_ONBOARDING_DONE"] = 237] = "TOPICS_ONBOARDING_DONE";
    BiEventType[BiEventType["REDIRECT_TO_LOGIN"] = 240] = "REDIRECT_TO_LOGIN";
    BiEventType[BiEventType["CLICK_JOIN"] = 241] = "CLICK_JOIN";
    BiEventType[BiEventType["CLICK_LOGIN"] = 242] = "CLICK_LOGIN";
    BiEventType[BiEventType["SIGNUP_SCREEN_SHOW"] = 243] = "SIGNUP_SCREEN_SHOW";
    BiEventType[BiEventType["LOGIN_SCREEN_SIGNUP_CLICK"] = 244] = "LOGIN_SCREEN_SIGNUP_CLICK";
    BiEventType[BiEventType["LOGIN_ON_SIGNUP_CLICK"] = 245] = "LOGIN_ON_SIGNUP_CLICK";
    BiEventType[BiEventType["SIGNUP_ON_SIGNUP_CLICK"] = 247] = "SIGNUP_ON_SIGNUP_CLICK";
    BiEventType[BiEventType["SIGNUP_SUCCESS"] = 248] = "SIGNUP_SUCCESS";
    BiEventType[BiEventType["SIGNUP_ERROR"] = 249] = "SIGNUP_ERROR";
    BiEventType[BiEventType["PROFILE_LOAD_MORE_CLICK"] = 265] = "PROFILE_LOAD_MORE_CLICK";
    BiEventType[BiEventType["PROFILE_POST_FEED_DROPDOWN"] = 266] = "PROFILE_POST_FEED_DROPDOWN";
    BiEventType[BiEventType["GIVE_POINTS_CLICK"] = 272] = "GIVE_POINTS_CLICK";
    BiEventType[BiEventType["SEND_NOTE_CLICK"] = 273] = "SEND_NOTE_CLICK";
    BiEventType[BiEventType["GIFT_CLICK"] = 274] = "GIFT_CLICK";
    BiEventType[BiEventType["GIFT_SELECT_CLICK"] = 275] = "GIFT_SELECT_CLICK";
    BiEventType[BiEventType["PROFILE_COVER_CLICK"] = 276] = "PROFILE_COVER_CLICK";
    BiEventType[BiEventType["PROFILE_WATCH_INTRO"] = 277] = "PROFILE_WATCH_INTRO";
    BiEventType[BiEventType[// EDIT_WIDGET_CLICK = 278,
    // ADJUST_COVER_POSITION = 279,
    // REMOVE_WIDGET_CLICK = 280,
    // MOVE_WIDGET_CLICK = 281,
    // ADD_WIDGET_CLICK = 282,
    // ADD_WIDGET = 283,
    "ADD_NEW_CONTENT_CLICK"] = 284] = "ADD_NEW_CONTENT_CLICK";
    BiEventType[BiEventType["DONATE_POINTS_CLICK"] = 286] = "DONATE_POINTS_CLICK";
    BiEventType[BiEventType[// OPEN_FOR_COMMISSION_CLICK = 287,
    "PROFILE_GALLERY_VIEW_MODE_CLICK"] = 288] = "PROFILE_GALLERY_VIEW_MODE_CLICK";
    BiEventType[BiEventType["GALLERY_SEARCH_CLICK"] = 289] = "GALLERY_SEARCH_CLICK";
    BiEventType[BiEventType["PROFILE_SUB_NAV_BAR"] = 290] = "PROFILE_SUB_NAV_BAR";
    BiEventType[BiEventType["PROFILE_ABOUT_SIDEBAR"] = 291] = "PROFILE_ABOUT_SIDEBAR";
    BiEventType[BiEventType["PROFILE_SUB_NAV_BAR_TOGGLE"] = 292] = "PROFILE_SUB_NAV_BAR_TOGGLE";
    BiEventType[BiEventType["PROFILE_ORDER_COMMISSION"] = 293] = "PROFILE_ORDER_COMMISSION";
    BiEventType[BiEventType["DONATION_POOL_SETUP_CONFIRM"] = 296] = "DONATION_POOL_SETUP_CONFIRM";
    BiEventType[BiEventType[// CLICK_SOCIAL_LINK = 297,
    // PROFILE_BADGE_CLICK = 298,
    // GALLECTION_SEARCH_SUBMIT = 299,
    "NAVIGATION_ARROW_CLICK"] = 300] = "NAVIGATION_ARROW_CLICK";
    BiEventType[BiEventType["THEATRE_MODE"] = 301] = "THEATRE_MODE";
    BiEventType[BiEventType["FULLSCREEN_MODE"] = 302] = "FULLSCREEN_MODE";
    BiEventType[BiEventType["ZOOM_MODE"] = 303] = "ZOOM_MODE";
    BiEventType[BiEventType["BACK_TO_CLICK"] = 304] = "BACK_TO_CLICK";
    BiEventType[BiEventType["GIVE_BADGE_AWARD"] = 320] = "GIVE_BADGE_AWARD";
    BiEventType[BiEventType["BADGE_AWARD_CLICK"] = 321] = "BADGE_AWARD_CLICK";
    BiEventType[BiEventType["BADGE_TYPE_SELECT"] = 322] = "BADGE_TYPE_SELECT";
    BiEventType[BiEventType["BADGE_STATISTICS_CLICK"] = 323] = "BADGE_STATISTICS_CLICK";
    BiEventType[BiEventType["BADGE_HELP_CLICK"] = 324] = "BADGE_HELP_CLICK";
    BiEventType[BiEventType[// ADD_TO_COLLECTION_CLICK = 330,
    "ADD_TO_COLLECTION_DONE_CLICK"] = 331] = "ADD_TO_COLLECTION_DONE_CLICK";
    BiEventType[BiEventType[// POPUP_CLICK_UNDO_FAVE = 332,
    "POPUP_CLICK_ADD_TO_COLLECTION"] = 333] = "POPUP_CLICK_ADD_TO_COLLECTION";
    BiEventType[BiEventType[// ADD_TO_GROUP_CLICK = 340,
    // ADD_TO_GROUP_FOLDER_SELECT = 342,
    // ADD_TO_GROUP_SELECT = 341,
    "CLICK_DOWNLOAD_BUTTON"] = 350] = "CLICK_DOWNLOAD_BUTTON";
    BiEventType[BiEventType["DOWNLOAD_NOW_CLICK"] = 351] = "DOWNLOAD_NOW_CLICK";
    BiEventType[BiEventType["START_DOWNLOAD_CLICK"] = 352] = "START_DOWNLOAD_CLICK";
    BiEventType[BiEventType[// CLICK_SHARE = 355,
    // CLICK_SOCIAL_SHARE = 356,
    "CLICK_COPY"] = 357] = "CLICK_COPY";
    BiEventType[BiEventType["BUY_CLICK"] = 360] = "BUY_CLICK";
    BiEventType[BiEventType["GALLERY_PURCHASE"] = 361] = "GALLERY_PURCHASE";
    BiEventType[BiEventType["BUY_IN_POPUP_STORE"] = 362] = "BUY_IN_POPUP_STORE";
    BiEventType[BiEventType[// GO_TO_GALLERY = 363,
    "CHANGE_BACKGROUND_CLICK"] = 370] = "CHANGE_BACKGROUND_CLICK";
    BiEventType[BiEventType["DEVIATION_EDIT_CLICK"] = 371] = "DEVIATION_EDIT_CLICK";
    BiEventType[BiEventType["DEVIATION_DELETE_CLICK"] = 372] = "DEVIATION_DELETE_CLICK";
    BiEventType[BiEventType["SELECT_BACKGROUND"] = 373] = "SELECT_BACKGROUND";
    BiEventType[BiEventType["CLOSE_BACKGROUND_SELECTION_MODAL"] = 374] = "CLOSE_BACKGROUND_SELECTION_MODAL";
    BiEventType[BiEventType["BUY_CORE_BUTTON"] = 375] = "BUY_CORE_BUTTON";
    BiEventType[BiEventType["DELETE_DEVIATION_CONFIRM_CLICK"] = 376] = "DELETE_DEVIATION_CONFIRM_CLICK";
    BiEventType[BiEventType[// WATCH_AUTHOR = 380,
    "JOIN_GROUP"] = 381] = "JOIN_GROUP";
    BiEventType[BiEventType["TAG_CLICK"] = 391] = "TAG_CLICK";
    BiEventType[BiEventType["SUBJECT_CLICK"] = 392] = "SUBJECT_CLICK";
    BiEventType[BiEventType["LOCATION_CLICK"] = 393] = "LOCATION_CLICK";
    BiEventType[BiEventType["WATCH_SECTION_SELECT"] = 400] = "WATCH_SECTION_SELECT";
    BiEventType[BiEventType["CHANGE_FEED_MODE"] = 401] = "CHANGE_FEED_MODE";
    BiEventType[BiEventType["USER_OR_GROUP_FEED_SELECT"] = 402] = "USER_OR_GROUP_FEED_SELECT";
    BiEventType[BiEventType["FEED_SORT_ORDER_SELECT"] = 403] = "FEED_SORT_ORDER_SELECT";
    BiEventType[BiEventType["MANAGE_WATCHLIST"] = 404] = "MANAGE_WATCHLIST";
    BiEventType[BiEventType["WATCH_ITEM_REMOVE_CLICK"] = 405] = "WATCH_ITEM_REMOVE_CLICK";
    BiEventType[BiEventType["WATCH_SUGGESTION_REMOVE_CLICK"] = 406] = "WATCH_SUGGESTION_REMOVE_CLICK";
    BiEventType[BiEventType["WATCH_FILTER_TAB_SELECTION"] = 407] = "WATCH_FILTER_TAB_SELECTION";
    BiEventType[BiEventType["WATCH_FILTER_SEARCH_ICON_CLICK"] = 408] = "WATCH_FILTER_SEARCH_ICON_CLICK";
    BiEventType[BiEventType["WATCH_FILTER_CLOSE_SEARCH_CLICK"] = 409] = "WATCH_FILTER_CLOSE_SEARCH_CLICK";
    BiEventType[BiEventType["WATCH_FILTER_SEARCH"] = 410] = "WATCH_FILTER_SEARCH";
    BiEventType[BiEventType["WATCH_FILTER_SELECT_ALL_CLICK"] = 411] = "WATCH_FILTER_SELECT_ALL_CLICK";
    BiEventType[BiEventType["WATCH_GROUP_BY_ARTIST_CLICK"] = 412] = "WATCH_GROUP_BY_ARTIST_CLICK";
    BiEventType[BiEventType["WATCH_VIEW_ALL_BY_ARTIST"] = 413] = "WATCH_VIEW_ALL_BY_ARTIST";
    BiEventType[BiEventType["WATCH_DEVIATION_SELECT"] = 414] = "WATCH_DEVIATION_SELECT";
    BiEventType[BiEventType["WATCH_DEVIATION_DESELECT"] = 415] = "WATCH_DEVIATION_DESELECT";
    BiEventType[BiEventType["WATCH_CONFIRM_REMOVAL"] = 416] = "WATCH_CONFIRM_REMOVAL";
    BiEventType[BiEventType["MORE_MENU_CLICK"] = 417] = "MORE_MENU_CLICK";
    BiEventType[BiEventType["WATCH_POPUP_SAVE"] = 418] = "WATCH_POPUP_SAVE";
    BiEventType[BiEventType["WATCH_POPUP_REMOVE"] = 419] = "WATCH_POPUP_REMOVE";
    BiEventType[BiEventType["WATCH_POPUP_CLOSE"] = 420] = "WATCH_POPUP_CLOSE";
    BiEventType[BiEventType["WATCH_POPUP_SELECT_ALL"] = 421] = "WATCH_POPUP_SELECT_ALL";
    BiEventType[BiEventType["WATCH_POPUP_SELECT_NONE"] = 422] = "WATCH_POPUP_SELECT_NONE";
    BiEventType[BiEventType["WATCH_POPUP_UNDO_REMOVAL"] = 423] = "WATCH_POPUP_UNDO_REMOVAL";
    BiEventType[BiEventType["WATCH_MENU_ITEM_SELECTION"] = 424] = "WATCH_MENU_ITEM_SELECTION";
    BiEventType[BiEventType["WATCH_SUGGESTION_SELECT"] = 430] = "WATCH_SUGGESTION_SELECT";
    BiEventType[BiEventType["WATCH_SUGGESTION_LOAD_MORE"] = 431] = "WATCH_SUGGESTION_LOAD_MORE";
    BiEventType[BiEventType["WATCH_SUGGESTION_WATCH"] = 432] = "WATCH_SUGGESTION_WATCH";
    BiEventType[BiEventType["WATCH_SUGGESTION_SELECT_CANCEL"] = 433] = "WATCH_SUGGESTION_SELECT_CANCEL";
    BiEventType[BiEventType["WATCH_SUB_FILTER_OPEN"] = 434] = "WATCH_SUB_FILTER_OPEN";
    BiEventType[BiEventType["WATCH_SUB_FILTER_SELECT"] = 435] = "WATCH_SUB_FILTER_SELECT";
    BiEventType[BiEventType["BUY_CORE_BUTTON_CLICK"] = 500] = "BUY_CORE_BUTTON_CLICK";
    BiEventType[BiEventType["PACKAGE_PICKER_CLICK"] = 501] = "PACKAGE_PICKER_CLICK";
    BiEventType[BiEventType["GET_MORE_POINTS"] = 504] = "GET_MORE_POINTS";
    BiEventType[BiEventType[// CORE_UPSELL_CLICK = 510,
    "CREDIT_CARD_TOKENIZATION"] = 512] = "CREDIT_CARD_TOKENIZATION";
    BiEventType[BiEventType["PAYMENT_BUTTON_CLICK"] = 520] = "PAYMENT_BUTTON_CLICK";
    BiEventType[BiEventType["PAYMENT_TYPE_CLICK"] = 521] = "PAYMENT_TYPE_CLICK";
    BiEventType[BiEventType[// ADD_DISCOUNT_OPEN = 522,
    // ADD_DISCOUNT_CLICK = 523,
    // REMEMBER_CARD_CLICK = 524,
    "GET_MORE_POINTS_CLICK"] = 525] = "GET_MORE_POINTS_CLICK";
    BiEventType[BiEventType["CANCEL_SUBSCRIPTION_CLICK"] = 526] = "CANCEL_SUBSCRIPTION_CLICK";
    BiEventType[BiEventType["CANCEL_SUBSCRIPTION_CONFIRM"] = 527] = "CANCEL_SUBSCRIPTION_CONFIRM";
    BiEventType[BiEventType["TIER_ADD_NEW"] = 530] = "TIER_ADD_NEW";
    BiEventType[BiEventType["TIER_UPLOAD_COVER_IMAGE"] = 531] = "TIER_UPLOAD_COVER_IMAGE";
    BiEventType[BiEventType["TIER_ADD_CONTENT"] = 532] = "TIER_ADD_CONTENT";
    BiEventType[BiEventType["TIER_PREVIEW_CLICK"] = 533] = "TIER_PREVIEW_CLICK";
    BiEventType[BiEventType["TIER_PUBLISH"] = 535] = "TIER_PUBLISH";
    BiEventType[BiEventType["TIER_EDIT_CLICK"] = 536] = "TIER_EDIT_CLICK";
    BiEventType[BiEventType["TIER_UPDATE"] = 538] = "TIER_UPDATE";
    BiEventType[BiEventType["TIER_SAVE_AS_DRAFT"] = 539] = "TIER_SAVE_AS_DRAFT";
    BiEventType[BiEventType["TIER_SAVE_AS_DRAFT_CONFIRM"] = 540] = "TIER_SAVE_AS_DRAFT_CONFIRM";
    BiEventType[BiEventType["TIER_DELETE"] = 541] = "TIER_DELETE";
    BiEventType[BiEventType["TIER_DELETE_CONFIRM"] = 542] = "TIER_DELETE_CONFIRM";
    BiEventType[BiEventType["TIER_NAVIGATION_SELECT"] = 543] = "TIER_NAVIGATION_SELECT";
    BiEventType[BiEventType["TIER_VIEW_BUTTON"] = 544] = "TIER_VIEW_BUTTON";
    BiEventType[BiEventType["VIEW_TIER_UNIQUE"] = 545] = "VIEW_TIER_UNIQUE";
    BiEventType[BiEventType["VIEW_SUBSCRIPTION_TAB"] = 547] = "VIEW_SUBSCRIPTION_TAB";
    BiEventType[BiEventType["VIEW_COMMISSIONS_TAB"] = 548] = "VIEW_COMMISSIONS_TAB";
    BiEventType[BiEventType["VIEW_PREMIUM_GALLERIES_TAB"] = 549] = "VIEW_PREMIUM_GALLERIES_TAB";
    BiEventType[BiEventType["TIER_SUBSCRIBE"] = 550] = "TIER_SUBSCRIBE";
    BiEventType[BiEventType["TIER_UNSUBSCRIBE"] = 551] = "TIER_UNSUBSCRIBE";
    BiEventType[BiEventType["TIER_UNSUBSCRIBE_CONFIRM"] = 552] = "TIER_UNSUBSCRIBE_CONFIRM";
    BiEventType[BiEventType["TIER_UPGRADE"] = 553] = "TIER_UPGRADE";
    BiEventType[BiEventType[// CANCEL_SUBSCRIPTION_ONE = 561,
    // CANCEL_SUBSCRIPTION_TWO = 562,
    // CANCEL_SUBSCRIPTION_THREE = 563,
    "MORE_ACTIONS_GROUP_NOTIFICATION"] = 605] = "MORE_ACTIONS_GROUP_NOTIFICATION";
    BiEventType[BiEventType["VIEW_MODE_SELECT"] = 620] = "VIEW_MODE_SELECT";
    BiEventType[BiEventType["EXPAND_NOTIFICATIONS"] = 621] = "EXPAND_NOTIFICATIONS";
    BiEventType[BiEventType["VIEW_MORE_NOTIFICATIONS_CLICK"] = 623] = "VIEW_MORE_NOTIFICATIONS_CLICK";
    BiEventType[BiEventType["NOTIFICATIONS_SECTION_SELECT"] = 624] = "NOTIFICATIONS_SECTION_SELECT";
    BiEventType[BiEventType["NOTIFICATIONS_ITEM_SAVE"] = 627] = "NOTIFICATIONS_ITEM_SAVE";
    BiEventType[BiEventType["BEGIN_TAKEDOWN_PROCESS"] = 628] = "BEGIN_TAKEDOWN_PROCESS";
    BiEventType[BiEventType["NOTIFICATIONS_OPT_OUT"] = 629] = "NOTIFICATIONS_OPT_OUT";
    BiEventType[BiEventType["COMMISSION_ORDER_ACCEPTED"] = 633] = "COMMISSION_ORDER_ACCEPTED";
    BiEventType[BiEventType["COMMISSION_ORDER_DECLINED"] = 634] = "COMMISSION_ORDER_DECLINED";
    BiEventType[BiEventType["GROUP_INVITE_ACCEPTED"] = 635] = "GROUP_INVITE_ACCEPTED";
    BiEventType[BiEventType["GROUP_INVITE_DECLINED"] = 636] = "GROUP_INVITE_DECLINED";
    BiEventType[BiEventType["DEVIATION_TO_GROUP_ACCEPTED"] = 637] = "DEVIATION_TO_GROUP_ACCEPTED";
    BiEventType[BiEventType["DEVIATION_TO_GROUP_DECLINED"] = 638] = "DEVIATION_TO_GROUP_DECLINED";
    BiEventType[BiEventType["TAG_MODEL_REQUEST_CONFIRMED"] = 639] = "TAG_MODEL_REQUEST_CONFIRMED";
    BiEventType[BiEventType["TAG_MODEL_REQUEST_DENIED"] = 640] = "TAG_MODEL_REQUEST_DENIED";
    BiEventType[BiEventType["ELNINO_VIEW"] = 641] = "ELNINO_VIEW";
    BiEventType[BiEventType["NOTIFICATION_CLICK"] = 650] = "NOTIFICATION_CLICK";
    BiEventType[BiEventType["NOTIFICATION_GIVE_CLICK"] = 651] = "NOTIFICATION_GIVE_CLICK";
    BiEventType[BiEventType["LIVE_NOTIFICATION_TOGGLE"] = 652] = "LIVE_NOTIFICATION_TOGGLE";
    BiEventType[BiEventType["LIVE_NOTIFICATION_CLICK"] = 653] = "LIVE_NOTIFICATION_CLICK";
    BiEventType[BiEventType["LIVE_NOTIFICATION_ACTIVITY_OPTION"] = 654] = "LIVE_NOTIFICATION_ACTIVITY_OPTION";
    BiEventType[BiEventType[// LIVE_NOTIFICATION_CANCEL = 655,
    // LIVE_NOTIFICATION_VIEW = 656,
    "NEW_CHAT"] = 670] = "NEW_CHAT";
    BiEventType[BiEventType["ENABLE_FLOATING_CHAT"] = 671] = "ENABLE_FLOATING_CHAT";
    BiEventType[BiEventType[// CHAT_MESSAGE_PERMIT = 672,
    "ONLINE_MODE"] = 673] = "ONLINE_MODE";
    BiEventType[BiEventType["CHAT_MUTE_MODE"] = 674] = "CHAT_MUTE_MODE";
    BiEventType[BiEventType["CHAT_DROPDOWN_MENU"] = 677] = "CHAT_DROPDOWN_MENU";
    BiEventType[BiEventType["CHAT_SELECT"] = 678] = "CHAT_SELECT";
    BiEventType[BiEventType["CHAT_MAX_MIN"] = 679] = "CHAT_MAX_MIN";
    BiEventType[BiEventType["CHAT_ADD_MEDIA"] = 680] = "CHAT_ADD_MEDIA";
    BiEventType[BiEventType["ADD_MEDIA_TYPE"] = 681] = "ADD_MEDIA_TYPE";
    BiEventType[BiEventType["CHAT_SEND"] = 682] = "CHAT_SEND";
    BiEventType[BiEventType["ADD_USER_TO_CHAT"] = 683] = "ADD_USER_TO_CHAT";
    BiEventType[BiEventType["ADD_TO_GROUP_BUTTON"] = 684] = "ADD_TO_GROUP_BUTTON";
    BiEventType[BiEventType["CHAT_ACTION_CONFIRM"] = 685] = "CHAT_ACTION_CONFIRM";
    BiEventType[BiEventType["SELECT_CHAT_LIST"] = 686] = "SELECT_CHAT_LIST";
    BiEventType[BiEventType["CHAT_STATUS"] = 687] = "CHAT_STATUS";
    BiEventType[BiEventType["SEND_CHAT_BUTTON_CLICK"] = 688] = "SEND_CHAT_BUTTON_CLICK";
    BiEventType[BiEventType["DRAG_DEVIATION_TO_CHAT"] = 689] = "DRAG_DEVIATION_TO_CHAT";
    BiEventType[BiEventType[// TOP_NAV_CLICK = 700,
    // TOP_NAV_MENU_CLICK = 702,
    // SUBMIT_MENU_OPEN = 703,
    // SEARCH_CLICK = 710,
    "PROFILE_STATS_SIDEBAR"] = 830] = "PROFILE_STATS_SIDEBAR";
    BiEventType[BiEventType["STATS_CHANGE_LEVEL_CLICK"] = 831] = "STATS_CHANGE_LEVEL_CLICK";
    BiEventType[BiEventType["STATS_OVERVIEW_TAB_CLICK"] = 832] = "STATS_OVERVIEW_TAB_CLICK";
    BiEventType[BiEventType["STATS_TABLE_SORT_CLICK"] = 833] = "STATS_TABLE_SORT_CLICK";
    BiEventType[BiEventType["CLOSE_BANNER_AD"] = 8005] = "CLOSE_BANNER_AD";
})(BiEventType || (BiEventType = {}));
export var BiDataHook;
(function(BiDataHook) {
    BiDataHook["CODEBLOCK_BUTTON"] = 'code_block_button';
    BiDataHook["VIDEO_PLAYER"] = 'video_player';
    BiDataHook["DROPDOWN_LAYOUT_OPTIONS"] = 'dropdown_layout_options';
    BiDataHook["TOP_NAV"] = 'top_nav';
    BiDataHook["DEVIATION_NAV"] = 'deviation_nav';
    BiDataHook["FILTER_NAV"] = 'filter_nav';
    BiDataHook["CONTENT_ROW_IDX"] = 'content_row';
    BiDataHook["BROWSE_ALL_CONTENT"] = 'all_content';
    BiDataHook["DEVIATION_ART_STAGE"] = 'art_stage';
    BiDataHook["DEVIATION_ACTION_BAR"] = 'action_bar';
    BiDataHook["DEVIATION_ADD_TO_FAVES_POPUP"] = 'fave_pop_up';
    BiDataHook["DEVIATION_META"] = 'deviation_meta';
    BiDataHook["DEVIATION_TITLE"] = 'deviation_title';
    BiDataHook["DEVIATION_COMMENTS_COUNTER"] = 'comments_counter';
    BiDataHook["DEVIATION_FAVES_COUNTER"] = 'faves_counter';
    BiDataHook["DEVIATION_GROUPS_COUNTER"] = 'group_counter';
    BiDataHook["DEVIATION_FAVE_BUTTON"] = 'fave_button';
    BiDataHook["DEVIATION_COMMENT_BUTTON"] = 'comment_button';
    BiDataHook["DEVIATION_SHARE_BUTTON"] = 'share_button';
    BiDataHook["DEVIATION_WATCH_BUTTON"] = 'watch_button';
    BiDataHook["DEVIATION_DOWNLOAD_BUTTON"] = 'download_button';
    BiDataHook["DEVIATION_LINK"] = 'deviation_link';
    BiDataHook["DEVIATION_STD_THUMB"] = 'deviation_std_thumb';
    BiDataHook["DEVIATION_FAVERS_LIST"] = 'favers_list';
    BiDataHook["DEVIATION_AWARD_BADGE_BUTTON"] = 'deviation_award_badge_button';
    BiDataHook["NOTIFICATIONS_DROPDOWN"] = 'feedback_dropdown';
    BiDataHook["NOTIFICATIONS_ITEM"] = 'notification_item';
    BiDataHook["PROFILE_NAV"] = 'profile_nav';
    BiDataHook["PROFILE_GALLECTION_FOLDER"] = 'gallection_folder';
    BiDataHook["PROFILE_GALLECTION_FOLDER_ITEM"] = 'gallection_folder_';
    BiDataHook["PROFILE_GALLECTION_FOLDER_CHOOSER"] = 'gallection_chooser';
    BiDataHook["PROFILE_GALLECTION_FOLDER_DROPDOWN"] = 'gallection_dropdown';
    BiDataHook["WIDGET_HEADER"] = 'widget-header';
    BiDataHook["WIDGET_HEADER_COUNTER"] = 'widget-header-counter';
    BiDataHook["WIDGET_PROFILE_COMMENTS"] = 'profile-comments-widget';
    BiDataHook["FAVES_POPUP"] = 'fave_pop_up';
    BiDataHook["FAVES_POPUP_MESSAGE"] = 'fav_pop_up_message';
    BiDataHook["FAVE_BUTTON"] = 'fave_button';
    BiDataHook["USER_WATCH_BUTTON"] = 'user_watch_button';
    BiDataHook["USER_AVATAR"] = 'user_avatar';
    BiDataHook["USER_AVATAR_TOOLTIP"] = 'user_avatar_tooltip';
    BiDataHook["USER_LINK"] = 'user_link';
    BiDataHook["COMMENTS_THREAD"] = 'comments_thread';
    BiDataHook["COMMENTS_THREAD_STATS"] = 'comments_thread_stats';
    BiDataHook["COMMENTS_THREAD_COUNT"] = 'comments_count';
    BiDataHook["COMMENTS_THREAD_SORTING"] = 'comments_sorting_order';
    BiDataHook["COMMENTS_THREAD_ITEM"] = 'comments_thread_item';
    BiDataHook["COMMENT_BODY"] = 'comment_body';
    BiDataHook["COMMENT_ACTION_MENU"] = 'comment_action_menu';
    BiDataHook["COMMENT_FOOTER"] = 'comment_footer';
    BiDataHook["COMMENT_TIMESTAMP"] = 'comment_timestamp';
    BiDataHook["COMMENT_FEATURE_BUTTON"] = 'comment_feature_button';
    BiDataHook["COMMENT_DELETE_BUTTON"] = 'comment_delete_button';
    BiDataHook["COMMENT_BLOCK_BUTTON"] = 'comment_block_button';
    BiDataHook["COMMENT_SPAM_BUTTON"] = 'comment_spam_button';
    BiDataHook["COMMENT_EDIT_BUTTON"] = 'comment_edit_button';
    BiDataHook["COMMENT_REPLY_BUTTON"] = 'comment_reply_button';
    BiDataHook["COMMENT_LIKE_BUTTON"] = 'comment_like_button';
    BiDataHook["COMMENT_BADGE_BUTTON"] = 'comment_badge_button';
    BiDataHook["COMMENT_EDITOR"] = 'comment_editor';
    BiDataHook["CHAT_ICON_TITLE"] = 'chat_icon_title';
    BiDataHook["NEW_CHAT_BUTTON"] = 'new_chat_button';
    BiDataHook["CHAT_OPTIONS_BUTTON"] = 'chat_options_button';
    BiDataHook["MUTE_ALL_CHATS"] = 'mute_all_chats';
    BiDataHook["CHAT_GENERAL_TAB"] = 'chat_general_tab';
    BiDataHook["CHAT_REQUEST_TAB"] = 'chat_request_tab';
    BiDataHook["SPECIFIC_CHAT_HEADER"] = 'specific_chat_header';
    BiDataHook["SPECIFIC_CHAT_AVATAR"] = 'specific_chat_avatar';
    BiDataHook["MANAGE_CHAT_BUTTON"] = 'manage_chat_button';
    BiDataHook["MANAGE_CHAT_BUTTON_ALL_USERS"] = 'manage_chat_button_all_users';
    BiDataHook["MANAGE_CHAT_MENU_BACK"] = 'manage_chat_menu_back';
    BiDataHook["MANAGE_CHAT_MENU_ADD_USER_INPUT"] = 'manage_chat_menu_add_user_input';
    BiDataHook["MANAGE_CHAT_MENU_DELETE_INPUT_TEXT"] = 'manage_chat_menu_delete_input_text';
    BiDataHook["MANAGE_CHAT_MENU_ADD_USER_BUTTON"] = 'manage_chat_menu_add_user_button';
    BiDataHook["MANAGE_CHAT_MENU_USER_MENU"] = 'manage_chat_menu_user_menu';
    BiDataHook["MANAGE_CHAT_MENU_USER_MENU_SEND"] = 'manage_chat_menu_user_menu_send';
    BiDataHook["MANAGE_CHAT_MENU_USER_MENU_REMOVE_USER"] = 'manage_chat_menu_user_menu_remove_user';
    BiDataHook["MANAGE_CHAT_MENU_OWN_USER_LEAVE"] = 'manage_chat_menu_own_user_leave';
    BiDataHook["SPECIFIC_GROUP_CHAT_HEADER_OPTIONS"] = 'specific_group_chat_header_options';
    BiDataHook["SPECIFIC_GROUP_CHAT_HEADER_OPTIONS_PARTICIPANTS"] = 'specific_group_chat_header_options_participants';
    BiDataHook["SPECIFIC_GROUP_CHAT_HEADER_OPTIONS_RENAME"] = 'specific_group_chat_header_options_rename';
})(BiDataHook || (BiDataHook = {}));
export var BiUpdateType;
(function(BiUpdateType) {
    BiUpdateType[BiUpdateType["ADD"] = 0] = "ADD";
    BiUpdateType[BiUpdateType["CHANGE"] = 1] = "CHANGE";
})(BiUpdateType || (BiUpdateType = {}));
export var ReferralType;
(function(ReferralType) {
    ReferralType["FAVOURITE"] = 'favourite';
    ReferralType["ADD_TO_GROUP"] = 'add_to_group';
    ReferralType["WATCH"] = 'watch';
    ReferralType["EDIT_DEVIATION"] = 'edit_deviation';
    ReferralType["DELETE_DEVIATION"] = 'delete_deviation';
    ReferralType["MATURE"] = 'mature';
    ReferralType["ANTISOCIAL"] = 'members_only_art_viewing';
    ReferralType["POLL_VOTE"] = 'poll_vote';
    ReferralType["GIVE"] = 'give';
    ReferralType["DONATE_POINTS"] = 'donate_points';
    ReferralType["SUBMIT"] = 'submit';
    ReferralType["COMMENT_ACTION"] = 'comment_action';
    ReferralType["REPORT"] = 'report';
    ReferralType["NOTE"] = 'note';
    ReferralType["CHAT"] = 'chat';
    ReferralType["COMMENT"] = 'comment';
    ReferralType["EMPTY_COMMENT"] = 'empty_comment';
    ReferralType["HEADER"] = 'header';
    ReferralType["LOGIN"] = 'login';
    ReferralType["ANON_DOWNLOAD"] = 'anon_download';
    ReferralType["BACKGROUND_MODAL"] = 'background_modal';
    ReferralType["USER_STATS"] = 'user_stats';
    ReferralType["CUSTOM_BOX"] = 'custom_box';
    ReferralType["USER_SYMBOL_POPUP"] = 'user_symbol_popup';
    ReferralType["USER_SYMBOL_POPUP_EXTEND"] = 'user_symbol_popup_extend';
    ReferralType["SISU_FUNNEL_BANNER"] = 'sisu_funnel_banner';
    ReferralType["SISU_FUNNEL_NEXT_DEVIATION"] = 'next_deviation';
    ReferralType["BADGE_GET_FRAGMENTS"] = 'badge_get_fragments';
    ReferralType["ANON_NETWORKBAR"] = 'anon_networkbar';
    ReferralType["CREATE_COMMISSION"] = 'create_commission';
    ReferralType["CREATE_GALLERY"] = 'create_gallery';
    ReferralType["RECENT_VISITORS"] = 'recent_visitors';
    ReferralType["JOIN_GROUP"] = 'join_group';
    ReferralType["BILLING_PAYMENTS"] = 'billing_payments';
    ReferralType["CORE_BILLING_PAYMENTS"] = 'core_billing_payments';
    ReferralType["PURCHASE_HISTORY_BILLING_PAYMENTS"] = 'purchase_history_billing_payments';
    ReferralType["UPGRADE_CORE_BILLING_PAYMENTS"] = 'upgrade_core_billing_payments';
    ReferralType["ART_THEFT_DETECTION"] = 'art_theft_detection';
    ReferralType["MEMBER_SUBSCRIBE"] = 'member_subscribe';
    ReferralType["COMPARE_TIER_UNIQUE"] = 'compare_tier_unique';
    ReferralType["COMPARE_CONTENT_PAGE"] = 'compare_content_page';
    ReferralType["HOME_WIDGET"] = 'home_widget';
    ReferralType["ACTION_BAR"] = 'action_bar';
    ReferralType["PROMOTION_HOME"] = 'promotion_home';
    ReferralType["PROMOTION_DYW"] = 'promotion_dyw';
    ReferralType["SIDE_BAR_TIER_UNIQUE"] = 'side_bar_tier_unique';
    ReferralType["SIDE_BAR_CONTENT_PAGE"] = 'side_bar_content_page';
    ReferralType["SITE_FOOTER"] = 'site_footer';
    ReferralType["SUBSCRIPTIONS"] = 'subscriptions';
    ReferralType["SUBSCRIPTIONS_GO_LIVE"] = 'subscriptions_go_live';
    ReferralType["SUBSCRIPTIONS_TIER_CREATION"] = 'subscriptions_tier_creation';
    ReferralType["SUBSCRIPTIONS_TIER_DRAFT"] = 'subscriptions_tier_draft';
    ReferralType["TIER_UNIQUE"] = 'tier_unique';
    ReferralType["TIER_MODAL"] = 'tier_modal';
    ReferralType["CONTENT_PAGE"] = 'content_page';
    ReferralType["SUBSCRIPTIONS_WIDGET"] = 'subscriptions_widget';
    ReferralType["LOCKED_CONTENT"] = 'locked_content';
    ReferralType["TIER_CARD"] = 'tier_card';
    ReferralType["DAPROTECT_OFF"] = 'daprotect_off';
    ReferralType["DAPROTECT_TEMP"] = 'daprotect_temp';
    ReferralType["PAYWALL_WATCHERS_ONLY"] = 'paywall_watchers_only';
    ReferralType["PAYWALL_PG"] = 'paywall_pg';
    ReferralType["PAYWALL_PCP"] = 'paywall_pcp';
    ReferralType["PROMOTION_BANNER_USERMENU"] = 'promotion_banner_usermenu';
    ReferralType["PROMOTION_BANNER_CONTENT_PAGE"] = 'promotion_banner_content_page';
    ReferralType["PROMOTION_BANNER_HOME"] = 'promotion_banner_home';
    ReferralType["PROMOTION_BANNER_PROFILE"] = 'promotion_banner_profile';
    ReferralType["SIDEBAR_PROMOTION"] = 'sidebar_promotion';
    ReferralType["ART_STAGE_PROMOTION"] = 'art_stage_promotion';
    ReferralType["PROFILE_COVER_PROMOTION"] = 'profile_cover_promotion';
    ReferralType["PROFILE_SUBSCRIPTIONS"] = 'profile_subscriptions';
    ReferralType["SUBSCRIPTIONS_CORE_EXPIRED"] = 'subscriptions_core_expired';
    ReferralType["DYW_BIRTHDAY"] = 'dyw_birthday';
    ReferralType["HOMEPAGE_PROMOTION"] = 'homepage_promotion';
    ReferralType["PROTECT_LEFT"] = 'protect_left';
    ReferralType["PROTECT_TOP_BANNER"] = 'protect_top_banner';
    ReferralType["PROTECT_LIMIT_SPACE"] = 'protect_limit_space';
    ReferralType["SHARE_TO_POST"] = 'share_to_post';
    ReferralType["AWARD_BADGE"] = 'award_badge';
    ReferralType["SHOP_PREMIUM_GALLERIES"] = 'shop_premium_galleries';
    ReferralType["SHOP_PREMIUM_DOWNLOADS"] = 'shop_premium_downloads';
    ReferralType["WIDGET_PAYWALL_OVERLAY"] = 'widget_paywall_overlay';
    ReferralType["WIDGET_PAYWALL_PREVIEW"] = 'widget_paywall_preview';
    ReferralType["LLAMAFARM_WIDGET_PAYWALL_OVERLAY"] = 'llamafarm_widget_paywall_overlay';
    ReferralType["LLAMAFARM_WIDGET_PAYWALL_PREVIEW"] = 'llamafarm_widget_paywall_preview';
    ReferralType["BADGES_SPOTLIGHT_PAYWALL_OVERLAY"] = 'badges_spotlight_paywall_overlay';
    ReferralType["BADGES_SPOTLIGHT_PAYWALL_PREVIEW"] = 'badges_spotlight_paywall_preview';
    ReferralType["PROFILE_SKINS"] = 'profile_skins';
    ReferralType["CONTACT_US"] = 'contact_us';
    ReferralType["DREAMUP_LEFT"] = 'dreamup_left';
    ReferralType["DREAMUP_TOP_CREATE"] = 'dreamup_top_create';
    ReferralType["NSFG"] = 'nsfg';
    ReferralType["ANON_JOIN_NOTIFICATION"] = 'anon_join_notification';
    ReferralType["SELL_DEVIATION"] = 'sell_deviation';
})(ReferralType || (ReferralType = {}));
